import * as React from 'react';
import { __ } from 'react-i18n';
import { Link } from 'react-router';
import { __r } from 'react-i18n/lib';
import UserAvatar from './UserAvatar';
import { DsiSvgIcon, IconType } from '../../General/SvgIcon';
import styled from 'styled-components';

interface Props {
  handleLogoutUser: () => any;
  user: any;
}

export function HeaderMobileProfile({ handleLogoutUser, user }: Props) {
  return (
    <>
      {user ? (
        <LinkLogoutWrapper onClick={handleLogoutUser}>
          <DsiSvgIcon
            icon={IconType.logout}
            alt="user-logout"
            cursor={'pointer'}
          />
        </LinkLogoutWrapper>
      ) : (
        <></>
      )}

      <LinkLoginWrapper
        to={
          user
            ? __r('routes:moj-ucet', '/moj-ucet')
            : __r('routes:prihlasenie', '/prihlasenie')
        }
      >
        {user ? (
          <UserAvatar name={`${user.name || user.surname?`${user.name} ${user.surname}`:user.email}`} />
        ) : (
          <DsiSvgIcon icon={IconType.user} alt="user-icon" cursor={'pointer'} />
        )}
      </LinkLoginWrapper>
    </>
  );
}

const LinkLoginWrapper = styled(Link)`
  text-decoration: none;
`;
const LinkLogoutWrapper = styled(Link)`
  &:hover p {
    color: ${({ theme }) => theme.colors.textPrimary};
  }
`;
